// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_styles_home__13Q-E"};